import { capture } from '../sentry/capture';
import toast from 'react-hot-toast';

let deferredPrompt;

export const beforeInstallPrompt = () => {
  window.addEventListener('beforeinstallprompt', function(e) {
    deferredPrompt = e;
    deferredPrompt.userChoice
      .then(choiceResult => {
        // either "accepted" or "dismissed"
        if (choiceResult.outcome === 'accepted') {
          toast.success('Application installée avec succès');
        }
      })
      .catch(err => {
        console.log(err);
        capture(err);
      });
  });
};

export const cycleInstalledFirst = () => {
  console.log('Premiere installation');
  return;
};
